import { useEffect, useRef } from 'react'

/**
 * What waits on a person, kept current without pressing F5.
 *
 *  useFreshOnReturn(reload)   asks again the moment the person comes back to this window: somebody
 *                             else's decision, made in another window, is not on the page until it does
 *                             (the notification bell does the same, in useNotifications)
 *  workChanged()              said after acting on a document; the menu's counts listen for it
 */

export const WORK_CHANGED = 'protrack:work-changed'

export const workChanged = () => window.dispatchEvent(new Event(WORK_CHANGED))

export default function useFreshOnReturn(reload, alsoOn = []) {
  const latest = useRef(reload)
  latest.current = reload
  useEffect(() => {
    const again = () => latest.current()
    const onVisible = () => { if (document.visibilityState === 'visible') again() }
    const events = ['focus', ...alsoOn]
    events.forEach(e => window.addEventListener(e, again))
    document.addEventListener('visibilitychange', onVisible)
    return () => {
      events.forEach(e => window.removeEventListener(e, again))
      document.removeEventListener('visibilitychange', onVisible)
    }
  }, [alsoOn.join()]) // eslint-disable-line react-hooks/exhaustive-deps
}
